import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const projectSettingFeaturesAppEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-project-settings-features-app" */ './src/ui'),
	),
	getPreloadProps: () => ({}),
});
